/**
 * Destination after a successful login or signup (deep link support).
 */
export function getPostAuthRedirect(location, fallback = '/dashboard') {
  return location.state?.redirectTo || fallback
}
